export default [
  {
    path: '/elaboracao/tramite',
    name: 'tramite',
    component: () => import(/* webpackChunkName: "elaboracao-tramite" */ './tramitar.vue'),
    children: [
      {
        path: '/elaboracao/tramite/consultarContatoExterno',
        name: 'tramiteConsultarContatoExterno',
        components: {
          interessadoRouter: () => import(/* webpackChunkName: "elaboracao-tramite" */ '@/components/filtro-interessados/tramite')
        }
      },
      {
        path: '/elaboracao/tramite/manterContatoExterno',
        name: 'tramiteManterContatoExterno',
        components: {
          interessadoRouter: () => import(/* webpackChunkName: "elaboracao-tramite" */ '@/components/manter-processo/contatoExterno/manter/ManterContatoExterno')
        }
      }
    ]
  }, {
    path: '/elaboracao/tramite/confirmacao',
    name: 'tramiteConfirmacao',
    component: () => import(/* webpackChunkName: "elaboracao-tramite" */ '@/components/tramite/Confirmacao')
  }
]
